namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class FormatTimeEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "HH:mm", text: "15:30" });
            this.addItem({ id: "HH:mm a", text: "03:30 pm" });
            this.addItem({ id: "HH:mm A", text: "03:30 PM" });
            this.addItem({ id: "HH:mm:ss", text: "15:30:53" });
            this.addItem({ id: "HH:mm:ss a", text: "03:30:53 pm" });
            this.addItem({ id: "HH:mm:ss A", text: "03:30:53 PM" });
            this.addItem({ id: "CustomTime", text: "Custom Time" });
        }
    }
}